import { render } from "./SignatureTabs.vue?vue&type=template&id=193690ce"
import script from "./SignatureTabs.vue?vue&type=script&lang=js"
export * from "./SignatureTabs.vue?vue&type=script&lang=js"
script.render = render

export default script